import { RouterParamType } from "@/model/navModel";
import React, { FC, useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { Form, Input, Col, Row, DatePicker } from "antd";
import { useShipmentDetailModel } from "../shipmentDetailModel";

export const FormVal: FC<RouterParamType> = (detailsInfo) => {
    const { setBoxDetailDialog, setLogFormVal, getLogOne ,editFormVal} = useShipmentDetailModel(({ logFormVal }) => [logFormVal]);
    const [form] = Form.useForm();

    useEffect(() => {
        getLogOne(detailsInfo.id).then(res => {
            console.log(res)
            res && form.setFieldsValue(res)
        })
    }, [])

    const formChange = (val: any, obj: any) => {
        setLogFormVal(origin => ({ ...origin, ...obj }));
    }

    const formItemLayout = {
        labelCol: {
            span: 7,
        },
        wrapperCol: {
            span: 17,
        },
    }

    return (
        <YhBox title="" style={{ marginBottom: "10px" }}>
            <Form form={form} {...formItemLayout} onValuesChange={formChange} >
                <div className="process-form-container">
                    <div className="process-left">
                        <div className="process-item">
                            <span className="process-title">1.商检</span>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="商检日期" name="testTime">
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            allowClear
                                            disabled={editFormVal.status == 'shipment.bl'}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        <div className="process-item">
                            <span className="process-title">2.订舱</span>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="托运日期" name="consignmentTime">
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            allowClear
                                            disabled={editFormVal.status == 'shipment.bl'}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="ETD" name="etd">
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            allowClear
                                            disabled={editFormVal.status == 'shipment.bl'}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="ETA" name="eta">
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            allowClear
                                            disabled={editFormVal.status == 'shipment.bl'}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="订舱日期" name="bookingTime">
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            allowClear
                                            disabled={editFormVal.status == 'shipment.bl'}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="备注" name="consignmentNote">
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        <div className="process-item">
                            <span className="process-title">3.装柜</span>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="装柜完成日期" name="carryTime">
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            allowClear
                                            disabled={editFormVal.status == 'shipment.bl'}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="备注" name="carryNote">
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <span style={{ color: "blue", cursor: "pointer" }} onClick={() => { setBoxDetailDialog(true) }}>装柜详情</span>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="process-right">

                        <div className="process-item">
                            <span className="process-title">4.报关放行</span>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="海关放行日期" name="releaseTime">
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            allowClear
                                            disabled={editFormVal.status == 'shipment.bl'}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="报关单号" name="reportCode">
                                        <Input disabled={editFormVal.status == 'shipment.bl'}/>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="报关日期" name="declareTime">
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            allowClear
                                            disabled={editFormVal.status == 'shipment.bl'}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="备注" name="releaseNote">
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        <div className="process-item">
                            <span className="process-title">5.装船</span>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="实际装船日期" name="shipmentTime">
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            allowClear
                                            disabled={editFormVal.status == 'shipment.bl'}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="备注" name="shipmentNote">
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        <div className="process-item">
                            <span className="process-title">6.提单</span>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="提单号" name="ladingNum">
                                        <Input disabled={editFormVal.status == 'shipment.bl'} />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="提单日期" name="ladingTime">
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            allowClear
                                            disabled={editFormVal.status == 'shipment.bl'}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="航次船名" name="flight">
                                        <Input disabled={editFormVal.status == 'shipment.bl'}/>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="收回日期" name="backTime">
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            allowClear
                                            disabled={editFormVal.status == 'shipment.bl'}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="备注" name="ladingNote">
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        {/* <div className="process-item">
                            <span className="process-title">7.交单/寄单</span>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="交单日期" name="presentationTime">
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            allowClear
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="交单类型" name="presentationType">
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="预计收汇日期" name="certificatesTime">
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            allowClear
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="交单银行" name="bank">
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        <div className="process-item">
                            <span className="process-title">8.清关</span>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="清关日期" name="clearTime">
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            allowClear
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        <div className="process-item">
                            <span className="process-title">9.入库时间</span>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="入库日期" name="deliveryTime">
                                        <DatePicker
                                            format={"YYYY-MM-DD"}
                                            allowClear
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div> */}
                    </div>
                </div>
            </Form>
        </YhBox>
    )
}